export default "__VITE_ASSET__462b76ed__"